import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=35a587fe&"
import script from "./Proposals.vue?vue&type=script&lang=js&"
export * from "./Proposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a587fe')) {
      api.createRecord('35a587fe', component.options)
    } else {
      api.reload('35a587fe', component.options)
    }
    module.hot.accept("./Proposals.vue?vue&type=template&id=35a587fe&", function () {
      api.rerender('35a587fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Proposals.vue"
export default component.exports